import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { encodeEntities } from 'ng-zorro-antd/core/util';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzHighlightPipe = /*#__PURE__*/(() => {
  class NzHighlightPipe {
    UNIQUE_WRAPPERS = ['##==-open_tag-==##', '##==-close_tag-==##'];
    transform(value, highlightValue, flags, klass) {
      if (!highlightValue) {
        return value;
      }
      // Escapes regex keyword to interpret these characters literally
      const searchValue = new RegExp(highlightValue.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$&'), flags);
      const wrapValue = value.replace(searchValue, `${this.UNIQUE_WRAPPERS[0]}$&${this.UNIQUE_WRAPPERS[1]}`);
      return encodeEntities(wrapValue).replace(new RegExp(this.UNIQUE_WRAPPERS[0], 'g'), klass ? `<span class="${klass}">` : '<span>').replace(new RegExp(this.UNIQUE_WRAPPERS[1], 'g'), '</span>');
    }
    static ɵfac = function NzHighlightPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzHighlightPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "nzHighlight",
      type: NzHighlightPipe,
      pure: true
    });
  }
  return NzHighlightPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/**
 * @deprecated Will be removed in v21, use `NzHighlightPipe` directly instead.
 */
let NzHighlightModule = /*#__PURE__*/(() => {
  class NzHighlightModule {
    static ɵfac = function NzHighlightModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzHighlightModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzHighlightModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return NzHighlightModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzHighlightModule, NzHighlightPipe };
